/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBankCheck = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17.293 4.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L16.414 14H12V9.586zM14 10.414V12h1.586l4-4L18 6.414zM2 5h11v2H4v10h16v-5h2v7H2zm8 6H6V9h4zm0 4H6v-2h4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBankCheck as BankCheck };
